
import React, { Component, PureComponent } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { pushEventToGTM } from '../../../helpers/trackerManager';

import { CheckBox, Button, Radio } from "../../Forms/Forms";
import ForfaitRevisionItem from './forfaitRevisionItem';
import CONSTANTS from '../../../constants';
import PopUp from '../../popup/popup';
import APwarningPicto from '../../../images/AP/ap-warning.svg';
import ACwarningPicto from '../../../images/AC/ac-warning.svg';
import DSwarningPicto from '../../../images/DS/ds-warning.svg';
import OVwarningPicto from '../../../images/OV/ov-warning.svg';

const mapStateToProps = state => state;

class BesoinsDetailsListRevision extends PureComponent {
  static defaultProps = {
    className: "",
    data: {},
    numberOfselected: "",
  };
  constructor(props) {
    super(props);
    this.state = {
      blockEmpty: true,
      selectedData: this.props.data,
      showDetails: false,
      numberOfselected: 0,
      showOperations: false,
      selectedForfait: 0,
      showObligatoryOperationsPopup: false
    }
    this.selectThatForfait = this.selectThatForfait.bind(this);
    this.numberOfSelectedOperations = 0;
  }

  componentDidMount() {
    this.setState({ numberOfselected: this.props.numberOfselected })
  }
  selectThatForfait(isChecked, id, isOperation = false) {
    // this function add "isSelected (bool)" to selected forfaits and opearations(sous forfaits).
    let numberOfselected = this.state.numberOfselected;
    let data = JSON.parse(JSON.stringify(this.state.selectedData));
    const dataUpdatedWithSelectedForfaits = data.map(function (forfaitType, key) {
      forfaitType.SubFunctionList[0].ForfaitList = forfaitType.SubFunctionList[0].ForfaitList.map(function (forfait, keyforfait) {

        // Check Forfaits
        if (!isOperation) {
          if (forfait.Items[0].Ref == id) {
            forfait['isSelected'] = true;
            numberOfselected++;
          } else {
            forfait['isSelected'] = false;

          }
        }

        // Check Operations 

        if (forfait.Operations != null) {

          forfait.Operations = forfait.Operations.map(function (Operation, opKey) {
            if (Operation.Items[0].Ref == id)
              if (isChecked) {
                Operation['isSelected'] = true;

              }
              else {
                Operation['isSelected'] = false;
              }
            return Operation;
          });
        }



        return forfait;
      });
      return forfaitType;
    });
    this.setState({ selectedData: dataUpdatedWithSelectedForfaits, numberOfselected: numberOfselected });
  }
  checkObligatoryOperations = () => {
    let selectedForfait = (this.state.selectedData[0].SubFunctionList[0].ForfaitList != null) && this.state.selectedData[0].SubFunctionList[0].ForfaitList.filter(forfait => forfait.isSelected)
    let operations = selectedForfait[0].Operations
    let selectedOperations = (operations != null) &&  operations.filter(operation => operation.isSelected)
    this.numberOfSelectedOperations = selectedOperations.length
    if (operations != null && !this.numberOfSelectedOperations) {
      this.setState({ showObligatoryOperationsPopup: true })
    }
    else {
      this.props.getSelectedForfait(this.state.selectedData);
    }
  }

  render() {
    let warningPicto = ''
    switch (CONSTANTS.SITE_CONFIG.currentBrand) {
      case 'P':
        warningPicto = APwarningPicto
        break;
      case 'C':
        warningPicto = ACwarningPicto
        break;
      case 'D':
        warningPicto = DSwarningPicto
        break;
      case 'V':
        warningPicto = OVwarningPicto
        break;
      default:
        warningPicto = APwarningPicto;
    }
    const popInObligatoryOperationsContent = <> <div className='warning-content'>
      <p className='warning-label1'>{CONSTANTS.LABELS.needs_basket_maintenance_alert_label1}</p>
      <div className='warning-list'>
        <p className='warning-label2'>{CONSTANTS.LABELS.needs_basket_maintenance_alert_label2}</p>
        <p className='warning-label3'>{CONSTANTS.LABELS.needs_basket_maintenance_alert_label3}</p>
      </div>
    </div>
    </>
    return (
      <div className="family-services__list services-wrapper forfait-revision-wrapper">
        <div className="serices__items">


          {this.state.selectedData.map(function (forfaitType) {
            return Object.values(forfaitType.SubFunctionList).length > 0 &&
              forfaitType.SubFunctionList[0].ForfaitList.map(function (forfait, keyforfait) {
                return (<ForfaitRevisionItem
                  data={forfait}
                  /* disable showing Revision details on PopIn
                   getshowDetails={(detailsComments)=> 
                     this.props.getshowDetails(detailsComments)
                   }*/
                  key={forfait.Items[0].Ref}
                  enableAddButton={(isChecked) => this.setState({ numberOfselected: 1 })}
                  familyCode={forfaitType.SubFunctionList[0].Code}
                  updateSelectedForfait={(isChecked, ref) => {
                    this.setState({ selectedForfait: ref });
                    this.selectThatForfait(isChecked, ref)
                  }}
                  updateSelectedOperation={(isChecked, ref) => {
                    this.selectThatForfait(isChecked, ref, true);
                  }
                  }
                  selectedForfait={this.state.selectedForfait}
                />)

              }.bind(this))
          }.bind(this))}
          <div className="serices__items_footer footer-wrapper">
            <div className="serices__items_footer block_footer_form">
              <Button classes={(this.state.numberOfselected < 1 ? 'disabled' : '')}
                onClick={() => {
                  this.checkObligatoryOperations();
                  pushEventToGTM({
                    pageName: 'services',
                    eventAction: 'Click::CTA',
                    eventLabel: 'operations_add_revision'
                  });
                }}
                Disabled={this.state.numberOfselected < 1}>
                {CONSTANTS.LABELS.common_v2_add}
              </Button>
            </div>

            <div className="serices__items_footer block_footer_content">

              <p dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.needs_basket_label4) }}></p>
            </div>
          </div>
        </div>
        { // show popup if no obligatory operation  is selected  
          this.state.showObligatoryOperationsPopup &&
          <PopUp
            title={CONSTANTS.LABELS.needs_basket_maintenance_alert_title}
            titlePicto={
              {
                showTitlePicto: true,
                src: warningPicto,
                alt: 'warning'
              }
            }
            showTitlePicto={true}
            content={popInObligatoryOperationsContent}
            primaryButtonLabel={CONSTANTS.LABELS.needs_basket_maintenance_alert_choose}
            secondaryButtonLabel={CONSTANTS.LABELS.needs_basket_maintenance_alert_ignore}
            handlePrimaryButton={() => this.setState({ showObligatoryOperationsPopup: false })}
            handleSecondaryButton={() => this.props.getSelectedForfait(this.state.selectedData)}
          />
        }
      </div>
    );
  }
}
export default connect(mapStateToProps)(BesoinsDetailsListRevision);
